import React from "react";
import "./App.css";
import axios from "axios";
import Main from "./components/Main/Main";
import SignIn from "./components/SignIn/SignIn";
import SignUp from "./components/SignUp/SignUp";
import Inscribe from "./components/Inscribe/Inscribe";
import Tutorials from "./components/Tutorials/Tutorials";
import History from "./components/History/History";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Feria from "./components/History/Feria";
import Categories from "./components/Categories/Categories";
import Projects from "./components/Categories/Projects";
import Project from "./components/Project/Project";
import Judges from "./components/Judges/Judges";
import Recovery from "./components/Utils/Recovery";
import Cookies from "universal-cookie";
import { useState, useEffect } from "react";
import Admin from "./components/Admin/Admin";
import LoginVerification from "./components/OAuth/LoginVefication";
const cookie = new Cookies();

function App() {
  const [judgeState, setJudgeState] = useState(false);
  const [adminState, setAdminState] = useState(false);

  useEffect(() => {
    if(cookie.get("judge")) setJudgeState(true)
    if(cookie.get("admin")) setAdminState(true)
  },[judgeState, adminState]);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Main />} exact />
          <Route path="/account" element={<SignIn />} exact />
          <Route path="/inscribe" element={<Inscribe />} exact />
          <Route path="/tutorials" element={<Tutorials />} exact />
          <Route path="/history" element={<History />} exact />
          <Route path="/history/:event" element={<Feria />} exact />
          <Route path="/categories" element={<Categories />} exact />
          <Route
            path="/categories/:id/:category"
            element={<Projects />}
            exact
          />
          <Route path="/projects/:code" element={<Project />} exact />
          {judgeState && <Route path="/judges" element={<Judges />} exact />}
          {adminState && (
            <Route path="/administration" element={<Admin />} exact />
          )}
          <Route path="/verification/:account" element={<LoginVerification />} exact />
          <Route path="/recovery" element={<Recovery />} exact />

          <Route path="*" element={<p>Redirecting...</p>} exact />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
